import React, { useEffect, useState } from 'react'

import { CHART_COLORS, transparentize } from '@auteco/utils/chartsUtils'
import sparePartsService from 'src/services/sparePartsService'
import SparePartsPage from 'src/pages/SparePartsPage/SparePartsPage'
import swal from 'sweetalert'
import { swalMessages } from 'src/constants'

const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July']

export const data2 = {
  labels,
  datasets: [
    {
      type: 'line',
      label: 'Compras',
      borderColor: CHART_COLORS.green,
      backgroundColor: CHART_COLORS.red,
      borderWidth: 4,
      fill: false,
      radius: 5,
      data: [],
      table: [],
    },
  ],
}

const arrayDataSetConfig = (
  array,
  label,
  type,
  param,
  backgroundColor,
  yAxisID,
  fill,
  order,
  displaysArray,
  index,
  paramSum,
) => {

  let data = []

  const table = array.map((inv) => Number(inv[param]).toFixed(0))
  if (paramSum !== undefined) {
    data = array.map((inv) =>
      inv[param] > 0
        ? Number(inv[param]) + Number(inv[paramSum])
        : Number(inv[param]).toFixed(0),
    )
  } else {
    data = array.map((inv) => Number(inv[param]).toFixed(0))
  }
  return {
    type,
    label,
    backgroundColor,
    data,
    table,
    borderColor: backgroundColor,
    borderWidth: 2,
    radius: 5,
    yAxisID,
    stacked: false,
    fill,
    order,
    hidden: !displaysArray[index],
  }
}

const initialDisplayedUnits = [
  true,
  true,
  true,
  true,
  true,
  true,
  true,
  true,
  true,
  true,
  true,
  true,
]

const initialDisplayedDays = [
  true,
  true,
  true,
  true,
  false
]

const SparePartsContainer = () => {
  const [graphicData, setGraphicData] = useState(data2)
  const [graphicDataDays, setGraphicDataDays] = useState(data2)
  const [filters, setFilters] = useState([])
  const [topTen, setTopTen] = useState([])
  const [forms, setForms] = useState({})
  const [models, setModels] = useState([])

  const arrayDisplayUnits = JSON.parse(localStorage.getItem('displays_units'))
  const arrayDisplayDays = JSON.parse(localStorage.getItem('displays_days'))
  const [displaysUnits, setDisplaysUnits] = useState(arrayDisplayUnits)
  const [displaysDays, setDisplaysDays] = useState(arrayDisplayDays)

  const updateArrayDisplayUnits = (array, index, newValue) => {
    array.splice(index, 1, newValue)
    setDisplaysUnits(array)
    localStorage.setItem('displays_units', JSON.stringify(array))
  }

  const updateArrayDisplayDays = (array, index, newValue) => {
    array.splice(index, 1, newValue)
    setDisplaysDays(array)
    localStorage.setItem('displays_days', JSON.stringify(array))
  }

  const handleDisplayUnits = (legendItem, legend) => {
    const index = legendItem.datasetIndex
    const ci = legend.chart
    if (ci.isDatasetVisible(index)) {
      ci.hide(index)
      updateArrayDisplayUnits(displaysUnits, index, false)
    } else {
      ci.show(index)
      updateArrayDisplayUnits(displaysUnits, index, true)
    }
  }
  const handleDisplayDays = (legendItem, legend) => {
    const index = legendItem.datasetIndex
    const ci = legend.chart
    if (ci.isDatasetVisible(index)) {
      ci.hide(index)
      updateArrayDisplayDays(displaysDays, index, false)
    } else {
      ci.show(index)
      updateArrayDisplayDays(displaysDays, index, true)
    }
  }

  const getFilters = async () => {
    const isStorageStateUnits = JSON.parse(localStorage.getItem('displays_units'))
    const isStorageStateDays = JSON.parse(localStorage.getItem('displays_days'))

    if (isStorageStateUnits) {
      setDisplaysUnits(isStorageStateUnits)
    } else {
      localStorage.setItem('displays_units', JSON.stringify(initialDisplayedUnits))
      setDisplaysUnits(initialDisplayedUnits)
    }

    if (isStorageStateDays) {
      setDisplaysDays(isStorageStateDays)
    } else {
      localStorage.setItem('displays_days', JSON.stringify(initialDisplayedDays))
      setDisplaysDays(initialDisplayedDays)
    }

    const { data } = await sparePartsService.getFiltersParts()
    if (data) setFilters(data)
    setFilters(data)
  }

  const generateDataSet = (data) => {
    const dataSet = {
      labels: data.map((mes) => mes.MES.slice(0, -3)),
      datasets: [
        arrayDataSetConfig(
          data,
          'Inventario en sitio fin de mes',
          'line',
          'InventarioEnSitioFinMes',
          CHART_COLORS.yamaha,
          'y',
          true,
          15,
          displaysUnits,
          0,
        ),
        arrayDataSetConfig(
          data,
          'Tránsito ordenes compras SAP',
          'line',
          'TransitoOrdenesCompraSap',
          transparentize(CHART_COLORS.auteco),
          'y',
          true,
          16,
          displaysUnits,
          1,
          'InventarioEnSitioFinMes',
        ),
        arrayDataSetConfig(
          data,
          'Inventario financiero',
          'line',
          'InventarioFinanciero',
          'rgb(255, 205, 86)',
          'y',
          false,
          3,
          displaysUnits,
          2,
        ),
        arrayDataSetConfig(
          data,
          'Ordenes compra + sin despachar + transito',
          'line',
          'OrdenesCompraSinDespachar',
          transparentize('#bc5090'),
          'y',
          true,
          17,
          displaysUnits,
          3,
          'InventarioEnSitioFinMes',
        ),
        arrayDataSetConfig(
          data,
          'Tubería',
          'line',
          'Tuberia',
          '#916997',
          'y',
          false,
          0,
          displaysUnits,
          4,
        ),
        arrayDataSetConfig(
          data,
          'Compras',
          'line',
          'Compras',
          'rgb(255, 99, 132)',
          'y',
          false,
          4,
          displaysUnits,
          5,
        ),
        arrayDataSetConfig(
          data,
          'Facturacion',
          'bar',
          'Facturacion',
          CHART_COLORS.green,
          'y',
          false,
          1,
          displaysUnits,
          6,
        ),
        arrayDataSetConfig(
          data,
          'Venta proyectada del mercado',
          'line',
          'VentaProyectadaMercadeoMostrar',
          '#FA0D1A',
          'y',
          false,
          13,
          displaysUnits,
          7,
        ),
        arrayDataSetConfig(
          data,
          'Salida reales',
          'bar',
          'SalidaReales',
          transparentize('#003f5c'),
          'y',
          false,
          2,
          displaysUnits,
          8,
        ),
        arrayDataSetConfig(
          data,
          'Llegadas reales',
          'line',
          'LllegadasReales',
          CHART_COLORS.blackLigth,
          'y',
          false,
          5,
          displaysUnits,
          9,
        ),
        arrayDataSetConfig(
          data,
          'Llegadas OC Proyección',
          'line',
          'LlegadasOCProyeccion',
          '#C5553D',
          'y',
          false,
          11,
          displaysUnits,
          10,
        ),
        arrayDataSetConfig(
          data,
          'Llegadas SAP Proyección',
          'line',
          'LlegadasSAPProyeccion',
          '#00CF36',
          'y',
          false,
          12,
          displaysUnits,
          11,
        )
      ],
    }
    setGraphicData(dataSet)
  }

  const generateDataSetDays = (data) => {
    const dataSet = {
      labels: data.map((mes) => mes.MES.slice(0, -3)),
      datasets: [
        arrayDataSetConfig(
          data,
          'Días inventario sitio total',
          'line',
          'DiasInventarioSitioTotal',
          '#74E1B0',
          'y',
          false,
          0,
          displaysDays,
          0,
        ),
        arrayDataSetConfig(
          data,
          'Días inventario sitio disponible',
          'line',
          'DiasInventarioSitioDisponible',
          '#8DAAA6',
          'y',
          false,
          1,
          displaysDays,
          1,
        ),
        arrayDataSetConfig(
          data,
          'Días inventario tránsito',
          'line',
          'DiasInventarioTransito',
          '#EEB797',
          'y',
          false,
          2,
          displaysDays,
          2,
        ),
        arrayDataSetConfig(
          data,
          'Días inventario tuberia financiero',
          'line',
          'DiasInventarioTuberiaFinanciero',
          '#5B3CE3',
          'y',
          false,
          3,
          displaysDays,
          3,
        ),
        arrayDataSetConfig(
          data,
          'Back order',
          'line',
          'BackOrder',
          'orange',
          'y',
          false,
          4,
          displaysDays,
          4,
        ),
      ],
    }
    setGraphicDataDays(dataSet)
  }

  const graphOnDemand = async (form) => {
    setGraphicData(data2)
    setGraphicDataDays(data2)
    const { data } = await sparePartsService.graphOnDemand(form)
    if (data) {
      generateDataSet(data)
      generateDataSetDays(data)
    }
  }

  const graphOnProyection = async (form) => {
    setGraphicData(data2)
    setGraphicDataDays(data2)
    const { data } = await sparePartsService.graphOnProyection(form)
    if (data) {
      generateDataSet(data)
      generateDataSetDays(data)
    }
  }

  const graphOnApplicationModels = async (form) => {
    const { data } = await sparePartsService.graphApplicationModels(form)
    if (data) {
      setModels(data)
    } else {
      swal(swalMessages.GENERAL_ERROR)
    }
  }

  const fetchTopTen = async (form) => {
    const { data } = await sparePartsService.topTen(form)
    if (data) {
      setTopTen(data)
    } else {
      swal(swalMessages.GENERAL_ERROR)
    }
  }

  const onSubmitForm = (form, type, setTop) => {
    setForms(form)
    if (setTop) {
      setTopTen([])
    }
    if (form.type === '1') {
      graphOnProyection(form)
      graphOnApplicationModels(form)
    } else {
      graphOnDemand(form)
      graphOnApplicationModels(form)
    }
    if (type) {
      fetchTopTen(form)
    }
  }

  useEffect(() => {
    getFilters()
  }, [])
  return (
    <>
      <SparePartsPage
        forms={forms}
        topTen={topTen}
        models={models}
        filters={filters}
        graphicData={graphicData}
        graphicDataDays={graphicDataDays}
        onSubmitForm={onSubmitForm}
        handleDisplayUnits={handleDisplayUnits}
        handleDisplayDays={handleDisplayDays}
      />
    </>
  )
}

export default SparePartsContainer
